import { WorkflowCaseStatus } from '@ebalance/proto/bffuser/v1/workflow_case_model_pb'

/**
 * ワークフローケースが「削除」可能かどうかを判定するヘルパー (spec AC-003f/AC-01、
 * workflow-delete-transition design)。未着手 (NOT_STARTED) または進行中
 * (IN_PROGRESS) のケースのみ削除できる。
 *
 * これは UX 目的の事前チェック (ボタンの出し分け) にすぎない。業務判断の正は
 * backend の workflowcase Usecase.Delete が持つ導出ステータスガードであり、
 * 完了・削除済みケースの削除は最終的に backend が FailedPrecondition で拒否する。
 *
 * 一覧 (`WorkflowCaseRow.status`) と詳細 (`WorkflowCase.status`) の両方で同一判定を
 * 使うため `src/models/` に集約する (= `isWorkflowCaseReadonly` と同パターン、
 * page-local model の複製を避ける)。判定に必要なのは status 値のみのため、
 * caller の型 (row / proto) に依存しない status 引数のみを取る。
 */
export function isWorkflowCaseDeletable(status: WorkflowCaseStatus): boolean {
  return (
    status === WorkflowCaseStatus.NOT_STARTED ||
    status === WorkflowCaseStatus.IN_PROGRESS
  )
}
